import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { store as RMStore, actions as RMActions } from '../flux/glob';
import Resource from './Resource';
import { config } from '../../../../pdc-platform/src/ts/config';
import { IRMInstanceState } from '../flux/Store';
import { IMarkedItems } from '../../../../pdc-platform/src/ts/Interfaces';

require('../../sass-main/pdc-widget-resource-manager.sass');

export interface IResourceListProperties {
    instanceId: string;
    view: number;
    dirContent?;
    selectedResources?: IMarkedItems;
    glob: IGlob;

    onSelect(selectedResources: IMarkedItems): void;
}

export default class ResourceList extends React.Component<
    IResourceListProperties,
    {
        RMState: IRMInstanceState;
        dirContent;
        selectedResources: IMarkedItems;
    }
> {
    constructor(props) {
        super(props);

        const rmState = RMStore.getInstanceState(this.props.instanceId);

        this.state = {
            RMState: rmState,
            dirContent: this.props.dirContent,
            selectedResources: this.props.selectedResources != null ? { ...this.props.selectedResources } : {}
        };
    }

    componentDidMount() {
        RMStore.addChangeListener(this.handleOnStoreChange);
    }

    componentDidUpdate(prevProps: IResourceListProperties, prevState) {
        if (
            JSON.stringify(prevProps.selectedResources) !== JSON.stringify(this.props.selectedResources) ||
            JSON.stringify(prevProps.dirContent) !== JSON.stringify(this.props.dirContent)
        ) {
            this.setState({
                selectedResources: this.props.selectedResources != null ? { ...this.props.selectedResources } : {},
                dirContent: this.props.dirContent
            });
        }
    }

    componentWillUnmount() {
        RMStore.removeChangeListener(this.handleOnStoreChange);
    }

    handleOnStoreChange = () => {
        const rmState = RMStore.getInstanceState(this.props.instanceId);

        this.setState({
            selectedResources: rmState.selectedResources != null ? { ...rmState.selectedResources } : {},
            dirContent: rmState.dirContent
        });
    };

    handleOnSelect = (id: number | string, name: string) => {
        const selectedResources: IMarkedItems = {};

        selectedResources[id] = name;

        if (typeof this.props.onSelect == 'function') {
            this.props.onSelect(selectedResources);
        }

        this.setState({
            selectedResources: selectedResources
        });
    };

    handleOnMultiSelect = (id: number | string, name: string) => {
        const selectedResources = { ...this.state.selectedResources };

        selectedResources[id] = name;

        if (typeof this.props.onSelect == 'function') {
            this.props.onSelect(selectedResources);
        }

        this.setState({
            selectedResources: selectedResources
        });
    };

    handleOnUnselect = (id: number | string) => {
        const selectedResources = { ...this.state.selectedResources };

        delete selectedResources[id];

        if (typeof this.props.onSelect == 'function') {
            this.props.onSelect(selectedResources);
        }

        this.setState({
            selectedResources: selectedResources
        });
    };

    render() {
        const { selectedResources: markedItems } = this.state;
        const endpoint = config.getAPIEndpoint() + '/';
        const rows = _.map(this.state.dirContent, (obj, i: number) => {
            const thumbnailUrl = endpoint + obj.thumbnail;
            const selected = markedItems[obj.resid] != null;

            return (
                <Resource
                    key={i}
                    index={i}
                    instanceId={this.props.instanceId}
                    view={this.props.view}
                    resid={obj.resid}
                    src={thumbnailUrl}
                    name={obj.name}
                    date={obj.date}
                    size={obj.size}
                    selected={selected}
                    glob={this.props.glob}
                    onSelect={this.handleOnSelect}
                    onMultiSelect={this.handleOnMultiSelect}
                    onUnselect={this.handleOnUnselect}
                />
            );
        });

        return (
            <div>
                <ul className="list-unstyled">{rows}</ul>
            </div>
        );
    }
}
